package org.multipaz.utopia.generated

/**
 * Generated strings for language: th
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_th = mapOf(
    "boarding_pass_attribute_departure_time" to "เวลาออกเดินทาง",
    "boarding_pass_attribute_flight_number" to "หมายเลขเที่ยวบิน",
    "boarding_pass_attribute_passenger_name" to "ชื่อผู้โดยสาร",
    "boarding_pass_attribute_seat_number" to "หมายเลขที่นั่ง",
    "boarding_pass_description_departure_time" to "วันที่และเวลาออกเดินทาง",
    "boarding_pass_description_flight_number" to "หมายเลขเที่ยวบิน",
    "boarding_pass_description_passenger_name" to "นามสกุล ชื่อสกุล หรือข้อมูลระบุตัวตนหลักของผู้ถือ mDL",
    "boarding_pass_description_seat_number" to "หมายเลขที่นั่ง",
    "cor_attribute_administrative_number" to "เลขทะเบียน",
    "cor_attribute_date_of_arrival" to "วันที่เดินทางมาถึง",
    "cor_attribute_date_of_birth" to "วันเดือนปีเกิด",
    "cor_attribute_date_of_expiry" to "วันหมดอายุ",
    "cor_attribute_date_of_issue" to "วันที่ออก",
    "cor_attribute_document_number" to "เลขที่เอกสาร",
    "cor_attribute_family_name" to "นามสกุล",
    "cor_attribute_gender" to "เพศ",
    "cor_attribute_given_names" to "ชื่อจริง",
    "cor_attribute_issuing_authority" to "หน่วยงานผู้ออก",
    "cor_attribute_issuing_country" to "ประเทศผู้ออก",
    "cor_attribute_issuing_jurisdiction" to "เขตอำนาจผู้ออก",
    "cor_attribute_nationality" to "สัญชาติ",
    "cor_attribute_older_than_18" to "อายุ 18 ปีขึ้นไป",
    "cor_attribute_older_than_21" to "อายุ 21 ปีขึ้นไป",
    "cor_attribute_place_of_birth" to "สถานที่เกิด",
    "cor_attribute_resident_address" to "ที่อยู่ผู้พักอาศัย",
    "cor_attribute_resident_city" to "เมืองที่พำนัก",
    "cor_attribute_resident_country" to "ประเทศที่พำนัก",
    "cor_attribute_resident_house_number" to "เลขที่บ้านที่พำนัก",
    "cor_attribute_resident_postal_code" to "รหัสไปรษณีย์ที่พำนัก",
    "cor_attribute_resident_state" to "รัฐที่พำนัก",
    "cor_attribute_resident_street" to "ถนนที่พำนัก",
    "cor_description_administrative_number" to "หมายเลขที่ผู้ให้บริการ COR กำหนดให้เพื่อการควบคุมการตรวจสอบหรือวัตถุประสงค์อื่น ๆ",
    "cor_description_date_of_arrival" to "วัน เดือน ปีที่ผู้ถือ COR เดินทางมาถึงสหภาพยุโรป",
    "cor_description_date_of_birth" to "วัน เดือน ปีเกิดของผู้ถือ COR หากไม่ทราบ ให้ระบุวันเกิดโดยประมาณ",
    "cor_description_date_of_expiry" to "วันที่ (และเวลา) ที่ COR จะหมดอายุ",
    "cor_description_date_of_issue" to "วันที่ (และเวลา) ที่ออก COR",
    "cor_description_document_number" to "หมายเลขสำหรับ COR ที่ผู้ให้บริการ COR กำหนดให้",
    "cor_description_family_name" to "นามสกุลปัจจุบัน หรือข้อมูลระบุตัวตนหลักของผู้ถือ COR",
    "cor_description_gender" to "เพศของผู้ถือ COR",
    "cor_description_given_names" to "ชื่อจริง ชื่ออื่นๆ ปัจจุบัน หรือข้อมูลระบุตัวตนรองของผู้ถือ COR",
    "cor_description_issuing_authority" to "ชื่อหน่วยงานบริหารที่ออก COR นี้ หรือรหัสประเทศ ISO 3166 Alpha-2 ของรัฐสมาชิกนั้น หากไม่มีหน่วยงานแยกต่างหากที่ได้รับอนุญาตให้ออก COR",
    "cor_description_issuing_country" to "รหัสประเทศ Alpha-2 ตามที่กำหนดใน ISO 3166-1 ของประเทศหรือดินแดนของหน่วยงานผู้ออก",
    "cor_description_issuing_jurisdiction" to "รหัสการแบ่งย่อยประเทศของเขตอำนาจศาลที่ออก COR ตามที่กำหนดใน ISO 3166-2:2020 ข้อ 8 ส่วนแรกของรหัสจะต้องเหมือนกับค่าสำหรับ issuing_country",
    "cor_description_nationality" to "รหัสประเทศ Alpha-2 ตามที่ระบุใน ISO 3166-1 ซึ่งแสดงถึงสัญชาติของผู้ใช้",
    "cor_description_older_than_18" to "อายุเกิน 18 ปีหรือไม่?",
    "cor_description_older_than_21" to "อายุเกิน 21 ปีหรือไม่?",
    "cor_description_place_of_birth" to "สถานที่เกิดของผู้ถือ COR",
    "cor_description_resident_address" to "ที่อยู่เต็มของสถานที่ที่ผู้ถือ COR พำนักอยู่ในปัจจุบันและ/หรือสามารถติดต่อได้ (เช่น เลขที่บ้าน/ถนน, เทศบาล ฯลฯ)",
    "cor_description_resident_city" to "เมืองที่ผู้ถือ COR พำนักอยู่ในปัจจุบัน",
    "cor_description_resident_country" to "ประเทศที่ผู้ใช้พำนักอยู่ในปัจจุบัน ในรูปแบบรหัสประเทศ Alpha-2 ตามที่ระบุใน ISO 3166-1",
    "cor_description_resident_house_number" to "เลขที่บ้านที่ผู้ใช้พำนักอยู่ในปัจจุบัน รวมถึงคำนำหน้าหรือคำต่อท้ายใดๆ",
    "cor_description_resident_postal_code" to "รหัสไปรษณีย์ของสถานที่ที่ผู้ถือ COR พำนักอยู่ในปัจจุบัน",
    "cor_description_resident_state" to "รัฐ จังหวัด เขต หรือท้องที่ที่ผู้ใช้พำนักอยู่ในปัจจุบัน",
    "cor_description_resident_street" to "ชื่อถนนที่ผู้ใช้พำนักอยู่ในปัจจุบัน",
    "cor_request_age_over_18" to "อายุเกิน 18 ปี",
    "cor_request_all_data_elements" to "องค์ประกอบข้อมูลทั้งหมด",
    "cor_request_mandatory_data_elements" to "องค์ประกอบข้อมูลบังคับ",
    "document_display_name_boarding_pass" to "บัตรผ่านขึ้นเครื่อง",
    "document_display_name_certificate_of_residency" to "หนังสือรับรองถิ่นที่อยู่",
    "document_display_name_german_personal_id" to "บัตรประจำตัวประชาชนเยอรมัน",
    "document_display_name_loyalty_card" to "บัตรสะสมคะแนน",
    "document_display_name_movie_ticket" to "ตั๋วภาพยนตร์",
    "document_display_name_naturalization_certificate" to "หนังสือรับรองการแปลงสัญชาติ",
    "document_display_name_payment_card" to "บัตรชำระเงิน",
    "german_id_attribute_administrative_number" to "หมายเลขราชการ",
    "german_id_attribute_age_in_years" to "อายุ (ปี)",
    "german_id_attribute_city_of_birth" to "เมืองที่เกิด",
    "german_id_attribute_country_of_birth" to "ประเทศที่เกิด",
    "german_id_attribute_date_of_birth" to "วันเดือนปีเกิด",
    "german_id_attribute_date_of_expiry" to "วันหมดอายุ",
    "german_id_attribute_date_of_issue" to "วันที่ออก",
    "german_id_attribute_document_number" to "หมายเลขเอกสาร",
    "german_id_attribute_family_name" to "นามสกุล",
    "german_id_attribute_family_name_at_birth" to "นามสกุลเมื่อเกิด",
    "german_id_attribute_gender" to "เพศ",
    "german_id_attribute_given_names" to "ชื่อ",
    "german_id_attribute_issuing_authority" to "หน่วยงานที่ออก",
    "german_id_attribute_issuing_country" to "ประเทศที่ออก",
    "german_id_attribute_issuing_jurisdiction" to "เขตอำนาจการออก",
    "german_id_attribute_nationality" to "สัญชาติ",
    "german_id_attribute_older_than_12" to "อายุมากกว่า 12 ปี",
    "german_id_attribute_older_than_14" to "อายุมากกว่า 14 ปี",
    "german_id_attribute_older_than_16" to "มากกว่า 16 ปี",
    "german_id_attribute_older_than_18" to "มากกว่า 18 ปี",
    "german_id_attribute_older_than_21" to "มากกว่า 21 ปี",
    "german_id_attribute_older_than_65" to "มากกว่า 65 ปี",
    "german_id_attribute_place_of_birth" to "สถานที่เกิด",
    "german_id_attribute_resident_address" to "ที่อยู่ปัจจุบัน",
    "german_id_attribute_resident_city" to "เมืองที่พำนัก",
    "german_id_attribute_resident_country" to "ประเทศที่พำนัก",
    "german_id_attribute_resident_postal_code" to "รหัสไปรษณีย์ที่พำนัก",
    "german_id_attribute_state_of_birth" to "รัฐที่เกิด",
    "german_id_attribute_year_of_birth" to "ปีเกิด",
    "german_id_description_administrative_number" to "หมายเลขที่กำหนดโดยผู้ให้บริการ PID สำหรับการควบคุมการตรวจสอบหรือวัตถุประสงค์อื่น ๆ",
    "german_id_description_age_in_years" to "อายุของผู้ถือ PID เป็นปี",
    "german_id_description_city_of_birth" to "เทศบาล เมือง ตำบล หรือหมู่บ้านที่ผู้ถือ PID เกิด",
    "german_id_description_country_of_birth" to "ประเทศที่ผู้ใช้ PID เกิด ในรูปแบบรหัสประเทศแบบ Alpha-2 ตามที่ระบุใน ISO 3166-1",
    "german_id_description_date_of_birth" to "วัน เดือน ปี ที่ผู้ถือ PID เกิด หากไม่ทราบ ให้ระบุวันเกิดโดยประมาณ",
    "german_id_description_date_of_expiry" to "วันที่ (และอาจรวมถึงเวลา) ที่ PID จะหมดอายุ",
    "german_id_description_date_of_issue" to "วันที่ (และอาจรวมถึงเวลา) ที่ออก PID",
    "german_id_description_document_number" to "หมายเลขสำหรับ PID ซึ่งกำหนดโดยผู้ให้บริการ PID",
    "german_id_description_family_name" to "นามสกุลปัจจุบัน หรือข้อมูลระบุตัวตนหลักของผู้ถือ PID",
    "german_id_description_family_name_at_birth" to "นามสกุล (นามสกุลเดิม) หรือตัวระบุหลักของผู้ถือ PID ณ เวลาเกิด",
    "german_id_description_gender" to "เพศของผู้ถือ PID",
    "german_id_description_given_names" to "ชื่อตัวปัจจุบัน หรือข้อมูลระบุตัวตนรองของผู้ถือ PID",
    "german_id_description_issuing_authority" to "ชื่อหน่วยงานราชการที่ออก PID นี้ หรือรหัสประเทศ Alpha-2 ตาม ISO 3166 ของประเทศสมาชิกที่เกี่ยวข้อง หากไม่มีหน่วยงานแยกต่างหากที่ได้รับอนุญาตให้ออก PID",
    "german_id_description_issuing_country" to "รหัสประเทศแบบ Alpha-2 ตามที่กำหนดใน ISO 3166-1 ของประเทศหรือดินแดนของหน่วยงานที่ออกให้",
    "german_id_description_issuing_jurisdiction" to "รหัสการแบ่งย่อยประเทศของเขตอำนาจที่ออก PID ตามที่กำหนดใน ISO 3166-2:2020, มาตรา 8 ส่วนแรกของรหัสจะต้องเหมือนกับค่าสำหรับ issuing_country",
    "german_id_description_nationality" to "รายการรหัสประเทศ Alpha-2 ตามที่ระบุใน ISO 3166-1 ซึ่งแสดงสัญชาติของผู้ถือ PID",
    "german_id_description_older_than_12" to "อายุเกิน 12 ปีใช่หรือไม่?",
    "german_id_description_older_than_14" to "อายุเกิน 14 ปีใช่หรือไม่?",
    "german_id_description_older_than_16" to "อายุเกิน 16 ปีใช่หรือไม่?",
    "german_id_description_older_than_18" to "อายุเกิน 18 ปีใช่หรือไม่?",
    "german_id_description_older_than_21" to "อายุเกิน 21 ปีใช่หรือไม่?",
    "german_id_description_older_than_65" to "อายุเกิน 65 ปีใช่หรือไม่?",
    "german_id_description_place_of_birth" to "ประเทศและเทศบาล หรือรัฐ/จังหวัดที่ผู้ถือ PID เกิด",
    "german_id_description_resident_address" to "ที่อยู่เต็มของสถานที่ที่ผู้ถือ PID พำนักในปัจจุบันและ/หรือสามารถติดต่อได้ (เลขที่บ้าน/ถนน, เทศบาล ฯลฯ)",
    "german_id_description_resident_city" to "เมืองที่ผู้ถือ PID พำนักในปัจจุบัน",
    "german_id_description_resident_country" to "ประเทศที่ผู้ถือ PID พำนักในปัจจุบัน ในรูปแบบรหัสประเทศ Alpha-2 ตามที่ระบุใน ISO 3166-1",
    "german_id_description_resident_postal_code" to "รหัสไปรษณีย์ของสถานที่ที่ผู้ถือ PID พำนักในปัจจุบัน",
    "german_id_description_state_of_birth" to "รัฐ จังหวัด เขต หรือพื้นที่ท้องถิ่นที่ผู้ใช้ PID เกิด",
    "german_id_description_year_of_birth" to "ปีที่ผู้ถือ PID เกิด",
    "german_id_request_age_over_18" to "อายุมากกว่า 18 ปี",
    "german_id_request_all_data_elements" to "องค์ประกอบข้อมูลทั้งหมด",
    "german_id_request_mandatory_data_elements" to "องค์ประกอบข้อมูลบังคับ",
    "loyalty_attribute_date_of_expiry" to "วันหมดอายุ",
    "loyalty_attribute_date_of_issue" to "วันที่ออก",
    "loyalty_attribute_family_name" to "นามสกุล",
    "loyalty_attribute_given_names" to "ชื่อ",
    "loyalty_attribute_membership_id" to "รหัสสมาชิก",
    "loyalty_attribute_photo_of_holder" to "รูปภาพผู้ถือบัตร",
    "loyalty_attribute_tier" to "ระดับ",
    "loyalty_description_date_of_expiry" to "วันที่เอกสารหมดอายุ",
    "loyalty_description_date_of_issue" to "วันที่ออกเอกสาร",
    "loyalty_description_family_name" to "นามสกุล หรือรหัสประจำตัวหลักของผู้ถือเอกสาร",
    "loyalty_description_given_names" to "ชื่อ หรือรหัสประจำตัวรองของผู้ถือเอกสาร",
    "loyalty_description_membership_id" to "รหัสประจำตัวสมาชิก Loyalty ID",
    "loyalty_description_photo_of_holder" to "รูปถ่ายของผู้ถือเอกสาร",
    "loyalty_description_tier" to "ระดับสมาชิก (พื้นฐาน, เงิน, ทอง, แพลทินัม, อีลิท)",
    "loyalty_request_all_data_elements" to "ข้อมูลทั้งหมด",
    "loyalty_request_mandatory_data_elements" to "ข้อมูลที่ต้องระบุ",
    "movie_ticket_attribute_age_rating_code" to "รหัสเรตติ้งอายุ",
    "movie_ticket_attribute_cinema_theater" to "โรงภาพยนตร์",
    "movie_ticket_attribute_date_and_time_of_show" to "วันที่และเวลาที่ฉาย",
    "movie_ticket_attribute_movie_poster" to "โปสเตอร์ภาพยนตร์",
    "movie_ticket_attribute_movie_title" to "ชื่อภาพยนตร์",
    "movie_ticket_attribute_parking" to "ที่จอดรถ",
    "movie_ticket_attribute_seat" to "ที่นั่ง",
    "movie_ticket_attribute_theater" to "โรงภาพยนตร์",
    "movie_ticket_attribute_ticket_number" to "หมายเลขตั๋ว",
    "movie_ticket_description_age_rating_code" to "รหัสเรตติ้งภาพยนตร์สำหรับจำกัดอายุ",
    "movie_ticket_description_cinema_theater" to "ชื่อโรงภาพยนตร์ และ/หรือที่อยู่/ตำแหน่งที่ตั้งของสถานที่เข้าชม",
    "movie_ticket_description_date_and_time_of_show" to "วันที่และเวลาที่ภาพยนตร์เริ่มฉาย",
    "movie_ticket_description_movie_poster" to "โปสเตอร์ภาพยนตร์",
    "movie_ticket_description_movie_title" to "ชื่อภาพยนตร์ ชื่อเรื่อง และข้อมูลระบุการแสดงอื่นๆ",
    "movie_ticket_description_parking" to "ระบุว่าค่าจอดรถชำระล่วงหน้าพร้อมตั๋วหรือไม่",
    "movie_ticket_description_seat" to "หมายเลขหรือรหัสที่นั่ง (เช่น แถว/ที่นั่ง)",
    "movie_ticket_description_theater" to "ชื่อหรือหมายเลขโรงภาพยนตร์",
    "movie_ticket_description_ticket_number" to "หมายเลขประจำตัวหรืออ้างอิงของตั๋วที่ออกให้ขณะซื้อ",
    "movie_ticket_request_all_data_elements" to "ข้อมูลทั้งหมด",
    "movie_ticket_request_prepaid_parking" to "ที่จอดรถแบบชำระล่วงหน้า",
    "movie_ticket_request_ticket_number" to "หมายเลขตั๋ว",
    "naturalization_attribute_date_of_birth" to "วันเกิด",
    "naturalization_attribute_date_of_naturalization" to "วันที่แปลงสัญชาติ",
    "naturalization_attribute_family_name" to "นามสกุล",
    "naturalization_attribute_given_names" to "ชื่อต้น",
    "naturalization_description_date_of_birth" to "วัน เดือน และปีที่ผู้แปลงสัญชาติเกิด หากไม่ทราบ ให้ระบุวันเกิดโดยประมาณ",
    "naturalization_description_date_of_naturalization" to "วันที่ (และเวลาหากมี) ที่บุคคลได้รับการแปลงสัญชาติ",
    "naturalization_description_family_name" to "นามสกุลปัจจุบัน หรือรหัสประจำตัวหลักของผู้แปลงสัญชาติ",
    "naturalization_description_given_names" to "ชื่อจริงปัจจุบัน ชื่ออื่น ๆ หรือรหัสประจำตัวรองของผู้แปลงสัญชาติ",
    "naturalization_request_all_data_elements" to "องค์ประกอบข้อมูลทั้งหมด",
    "payment_attribute_expiry_date" to "วันหมดอายุ",
    "payment_attribute_holder_name" to "ชื่อผู้ถือ",
    "payment_attribute_issue_date" to "วันที่ออก",
    "payment_attribute_issuer_name" to "ชื่อผู้ออก",
    "payment_attribute_masked_account_reference" to "การอ้างอิงบัญชีแบบปกปิด",
    "payment_attribute_payment_instrument_id" to "ID เครื่องมือชำระเงิน",
    "payment_description_expiry_date" to "วันที่ข้อมูลรับรองนี้หมดอายุ",
    "payment_description_holder_name" to "ชื่อเจ้าของบัญชีชำระเงิน",
    "payment_description_issue_date" to "วันที่ออกข้อมูลรับรองนี้",
    "payment_description_issuer_name" to "ชื่อผู้ออกที่อ่านเข้าใจง่าย",
    "payment_description_masked_account_reference" to "ข้อมูลอ้างอิงบัญชีแบบปกปิด เช่น PAN 4 ตัวท้าย",
    "payment_description_payment_instrument_id" to "รหัสระบุเครื่องมือชำระเงินแบบโทเค็น",
    "payment_request_payment_sca_all" to "SCA การชำระเงิน (ข้อมูลทั้งหมด)",
    "payment_request_payment_sca_minimal" to "SCA การชำระเงิน (ขั้นต่ำ)",
    "payment_request_payment_sca_transaction" to "SCA พร้อมธุรกรรมการชำระเงิน"
)
